import { generatePath } from '@shared/lib'
import { CYBER_PAY_URL_RESULT } from '@shared/config/constants'

export const getResultPath = (mdOrder: string, query?: string) => {
  const generatedPath = generatePath(CYBER_PAY_URL_RESULT, { mdOrder })

  return query ? `${generatedPath}${query}` : generatedPath
}
